import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["birthday", "birthdayLabel", "phone", "phoneLabel"]

  connect() {
    this.validationStarted = false
    this.element.dataset.cembrapayDataReady = "true"
  }

  disconnect() {
    delete this.element.dataset.cembrapayDataReady
  }

  validate(event) {
    this.validationStarted = true
    const birthdayValid = this.validateBirthday()
    const phonesValid = this.validatePhones()

    if (!birthdayValid || !phonesValid) event.preventDefault()
  }

  refreshBirthday() {
    if (this.validationStarted) this.validateBirthday()
  }

  refreshPhones() {
    if (this.validationStarted) this.validatePhones()
  }

  validateBirthday() {
    if (!this.hasBirthdayTarget) return true

    const valid = this.birthdayTargets.every(select => select.value)
    this.birthdayTargets.forEach(select => select.classList.toggle("empty", !select.value))
    this.birthdayLabelTarget.classList.toggle("empty", !valid)

    return valid
  }

  validatePhones() {
    if (!this.hasPhoneTarget) return true

    const valid = this.phoneTargets.some(input => input.value.trim())
    this.phoneTargets.forEach(input => input.classList.toggle("empty", !valid))
    this.phoneLabelTarget.classList.toggle("empty", !valid)

    return valid
  }
}
